import { render, staticRenderFns } from "./recitationAlertsView.vue?vue&type=template&id=ea7efb50&scoped=true&"
import script from "./recitationAlertsView.vue?vue&type=script&lang=js&"
export * from "./recitationAlertsView.vue?vue&type=script&lang=js&"
import style0 from "./recitationAlertsView.vue?vue&type=style&index=0&id=ea7efb50&prod&lang=scss&scoped=true&"
import style1 from "./recitationAlertsView.vue?vue&type=style&index=1&id=ea7efb50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7efb50",
  null
  
)

export default component.exports